import { Injectable } from "@angular/core";
import { State, Action, StateContext, Selector } from "@ngxs/store";
import {
  GetClientId,
  GetOrganizationUnitId,
  Login,
  SelectedCategory,
  SelectedDistributionLane,
  SelectedItem,
  SelectedItemServiceRate,
  SelectedWorkItem,
  SetConnectionId,
  SetDistributionLaneId,
  SelectedTenantId,
  SelectedLocationId,
  SelectedMenuItems,
  SelectedLocation,
  SelectedCompany,
  SelectedUser,
  SelectedAccount,
  SelectedPaymentMethod,
  SelectedOrder,
  AllowedLocations,
  SelectedVoucher,
  SelectedCustomer,SelectedOrderNote,SelectedUserPin,SelectedOrderStatus
} from "./order-portal-global.actions";
import { Category } from "../../models/category.model";
import { Authorize } from "../../models/authorize.model";
import { Item } from "../../models/item.model";
import { WorkItem } from "../../models/service.model";
import { ItemServiceRate } from "../../models/service.rate.model";
import { Company } from "../../models/company.mode";
import { MenuItem } from "../../models/menu.item.mode";

export class OrderPortalGlobalStateModel {
  tenantId: string | undefined;
  locationId:string|undefined;
  clientId: string | undefined;
  connectionId: string | undefined;
  organizationUnitId: string | undefined;
  subscriptionKeyInterceptor: string | undefined;
  selectedDistributionLane: string[] | undefined;
  distributionLaneId: string | undefined;
  authorize: Authorize | undefined;
  selectedCategory:Category|undefined;
  selectedItem:Item|undefined;
  selectedJobFields:string[]|undefined;
  selectedWorkItem:WorkItem|undefined;
  selectedItemServiceRate:ItemServiceRate|undefined;
  selectedMenuItems:MenuItem[]|undefined;
  selectedLocation:Location|undefined;
  selectedCompany:Company|undefined;
  selectedUser:any|undefined;
  selectedAccount:any|undefined;
  selectedPaymentMethod:any|undefined;
  selectedOrder:any|undefined;
  allowedLocations:any|undefined;
  selectedVoucher:any|undefined;
  selectedCustomer:any|undefined;
  selectedOrderNote:any|undefined;
  selectedUserPin:any|undefined;
  selectedOrderStatus:any|undefined;
}

const defaults = {
  tenantId:undefined,
  locationId:undefined,
  clientId: "bk",
  connectionId: "test_connection",
  organizationUnitId: "781CEFC1-DECC-403E-8D0B-466E0967593C",
  subscriptionKeyInterceptor: "dd98790b31c04f13b3e4b1a22c93232e",
  selectedDistributionLane: undefined,
  distributionLaneId: undefined,
  authorize: undefined,
  selectedCategory:undefined,
  selectedItem:undefined,
  selectedJobFields:undefined,
  selectedWorkItem:undefined,
  selectedItemServiceRate:undefined,
  selectedMenuItems:undefined,
  selectedLocation:undefined,
  selectedCompany:undefined,
  selectedUser:undefined,
  selectedAccount:undefined,
  selectedPaymentMethod:undefined,
  selectedOrder:undefined,
  allowedLocations:undefined,
  selectedVoucher:undefined,
  selectedCustomer:undefined,
  selectedOrderNote:undefined,
  selectedUserPin:undefined,
  selectedOrderStatus:undefined
};

@State<OrderPortalGlobalStateModel>({
  name: "orderPortalGlobal",
  defaults
})
@Injectable()
export class OrderPortalGlobalState {

  @Action(SelectedTenantId)
  setTenantId( ctx: StateContext<OrderPortalGlobalStateModel>,
    { payload }: SelectedTenantId) {
    ctx.setState({ ...ctx.getState(), tenantId: payload });
  }

  @Action(SelectedLocationId)
  setLocationId( ctx: StateContext<OrderPortalGlobalStateModel>,
    { payload }: SelectedLocationId) {
    ctx.setState({ ...ctx.getState(), locationId: payload });
  }

  @Action(GetClientId)
  getClientId(ctx: StateContext<OrderPortalGlobalStateModel>) {
    ctx.setState({ ...ctx.getState() });
  }

  @Action(GetOrganizationUnitId)
  getOrganizationUnitId(ctx: StateContext<OrderPortalGlobalStateModel>) {
    ctx.setState({ ...ctx.getState() });
  }

  @Action(SetConnectionId)
  setConnectionId(
    ctx: StateContext<OrderPortalGlobalStateModel>,
    { payload }: SetConnectionId
  ) {
    if (payload) {
      ctx.setState({ ...ctx.getState(), connectionId: payload });
    } else {
      ctx.setState({ ...ctx.getState() });
    }
  }

  @Action(SelectedDistributionLane)
  selectedDistributionLane(
    ctx: StateContext<OrderPortalGlobalStateModel>,
    { payload }: SelectedDistributionLane
  ) {
    ctx.setState({ ...ctx.getState(), selectedDistributionLane: payload });
  }

  @Action(SetDistributionLaneId)
  setDistributionLaneId(
    ctx: StateContext<OrderPortalGlobalStateModel>,
    { payload }: SetDistributionLaneId
  ) {
    ctx.setState({ ...ctx.getState(), distributionLaneId: payload });
  }

  @Action(Login)
  login(ctx: StateContext<OrderPortalGlobalStateModel>, { payload }: Login) {
    ctx.setState({ ...ctx.getState(), authorize: payload });
  }
  @Action(SelectedCategory)
  setSelectedCategory(ctx: StateContext<OrderPortalGlobalStateModel>, { payload }: SelectedCategory) {
    ctx.setState({ ...ctx.getState(), selectedCategory: payload });
  }

  @Action(SelectedItem)
  setSelectedItem(ctx: StateContext<OrderPortalGlobalStateModel>, { payload }: SelectedItem) {
    ctx.setState({ ...ctx.getState(), selectedItem: payload });
  }

  @Action(SelectedWorkItem)
  setSelectedWorkItem(ctx: StateContext<OrderPortalGlobalStateModel>, { payload }: SelectedWorkItem) {
    ctx.setState({ ...ctx.getState(), selectedWorkItem: payload });
  }
  @Action(SelectedItemServiceRate)
  setSelectedItemServiceRate(ctx: StateContext<OrderPortalGlobalStateModel>, { payload }: SelectedItemServiceRate) {
    ctx.setState({ ...ctx.getState(), selectedItemServiceRate: payload });
  }

  @Action(SelectedMenuItems)
  setSeletedMenuItems(ctx: StateContext<OrderPortalGlobalStateModel>, { payload }: SelectedMenuItems) {
    ctx.setState({ ...ctx.getState(), selectedMenuItems: payload });
  }

  @Action(SelectedLocation)
  setSeletedLocation(ctx: StateContext<OrderPortalGlobalStateModel>, { payload }: SelectedLocation) {
    ctx.setState({ ...ctx.getState(), selectedLocation: payload });
  }
  
  @Action(SelectedCompany)
  setSeletedCompany(ctx: StateContext<OrderPortalGlobalStateModel>, { payload }: SelectedCompany) {
    ctx.setState({ ...ctx.getState(), selectedCompany: payload });
  }
  @Action(SelectedUser)
  setSeletedUser(ctx: StateContext<OrderPortalGlobalStateModel>, { payload }: SelectedCompany) {
    ctx.setState({ ...ctx.getState(), selectedUser: payload });
  }
  @Action(SelectedUser)
  setSeletedAccount(ctx: StateContext<OrderPortalGlobalStateModel>, { payload }: SelectedAccount) {
    ctx.setState({ ...ctx.getState(), selectedAccount: payload });
  }

  @Action(SelectedPaymentMethod)
  setSeletedPaymentMethod(ctx: StateContext<OrderPortalGlobalStateModel>, { payload }: SelectedPaymentMethod) {
    ctx.setState({ ...ctx.getState(), selectedPaymentMethod: payload });
  }
  
  @Action(SelectedOrder)
  setSeletedOrder(ctx: StateContext<OrderPortalGlobalStateModel>, { payload }: SelectedOrder) {
    ctx.setState({ ...ctx.getState(), selectedOrder: payload });
  }
  @Action(AllowedLocations)
  setAllowedLocations(ctx: StateContext<OrderPortalGlobalStateModel>, { payload }: AllowedLocations) {
    ctx.setState({ ...ctx.getState(), allowedLocations: payload });
  }
  @Action(SelectedVoucher)
  setSelectedVoucher(ctx: StateContext<OrderPortalGlobalStateModel>, { payload }: SelectedVoucher) {
    ctx.setState({ ...ctx.getState(), selectedVoucher: payload });
  }
  @Action(SelectedCustomer)
  setSelectedCustomer(ctx: StateContext<OrderPortalGlobalStateModel>, { payload }: SelectedCustomer) {
    ctx.setState({ ...ctx.getState(), selectedCustomer: payload });
  }
  @Action(SelectedOrderNote)
  setSelectedOrderNote(ctx: StateContext<OrderPortalGlobalStateModel>, { payload }: SelectedOrderNote) {
    ctx.setState({ ...ctx.getState(), selectedOrderNote: payload });
  }
  @Action(SelectedUserPin)
  setSelectedUserPin(ctx: StateContext<OrderPortalGlobalStateModel>, { payload }: SelectedUserPin) {
    ctx.setState({ ...ctx.getState(), selectedUserPin: payload });
  }

  @Action(SelectedOrderStatus)
  setSelectedOrderStatus(ctx: StateContext<OrderPortalGlobalStateModel>, { payload }: SelectedOrderStatus) {
    ctx.setState({ ...ctx.getState(), selectedOrderStatus: payload });
  }
  @Selector()
  static TenantId(state: OrderPortalGlobalStateModel) {
    return state.tenantId;
  }
  @Selector()
  static LocationId(state: OrderPortalGlobalStateModel) {
    return state.locationId;
  }

  @Selector()
  static ClientId(state: OrderPortalGlobalStateModel) {
    return state.clientId;
  }

  @Selector()
  static OrganizationUnitId(state: OrderPortalGlobalStateModel) {
    return state.organizationUnitId;
  }

  @Selector()
  static ConnectionId(state: OrderPortalGlobalStateModel) {
    return state.connectionId;
  }

  @Selector()
  static SubscriptionKeyInterceptor(state: OrderPortalGlobalStateModel) {
    return state.subscriptionKeyInterceptor;
  }

  @Selector()
  static SelectedDistributionLane(state: OrderPortalGlobalStateModel) {
    return state.selectedDistributionLane;
  }

  @Selector()
  static DistributionLaneId(state: OrderPortalGlobalStateModel) {
    return state.distributionLaneId;
  }

  @Selector()
  static Authorize(state: OrderPortalGlobalStateModel) {
    return state.authorize;
  }

  @Selector()
  static SelectedCategory(state: OrderPortalGlobalStateModel) {
    return state.selectedCategory;
  }
  @Selector()
  static SelectedItem(state: OrderPortalGlobalStateModel) {
    return state.selectedItem;
  }
  @Selector()
  static SelectedWorkItem(state: OrderPortalGlobalStateModel) {
    return state.selectedWorkItem;
  }
  @Selector()
  static SelectedItemServiceRate(state: OrderPortalGlobalStateModel) {
    return state.selectedItemServiceRate;
  }
  @Selector()
  static SelectedMenuItems(state: OrderPortalGlobalStateModel) {
    return state.selectedMenuItems;
  }
  @Selector()
  static SelectedLocation(state: OrderPortalGlobalStateModel) {
    return state.selectedLocation;
  }
  @Selector()
  static SelectedCompany(state: OrderPortalGlobalStateModel) {
    return state.selectedCompany;
  }
  @Selector()
  static SelectedUser(state: OrderPortalGlobalStateModel) {
    return state.selectedUser;
  }
  @Selector()
  static SelectedAccount(state: OrderPortalGlobalStateModel) {
    return state.selectedAccount;
  }
  @Selector()
  static SelectedPaymentMethod(state: OrderPortalGlobalStateModel) {
    return state.selectedPaymentMethod;
  }
  @Selector()
  static SelectedOrder(state: OrderPortalGlobalStateModel) {
    return state.selectedOrder;
  }
  @Selector()
  static AllowedLocations(state: OrderPortalGlobalStateModel) {
    return state.allowedLocations;
  }
  @Selector()
  static SelectedVoucher(state: OrderPortalGlobalStateModel) {
    return state.selectedVoucher;
  }
  @Selector()
  static SelectedCustomer(state: OrderPortalGlobalStateModel) {
    return state.selectedCustomer;
  }
  @Selector()
  static SelectedOrderNote(state: OrderPortalGlobalStateModel) {
    return state.selectedOrderNote;
  }
  @Selector()
  static SelectedUserPin(state: OrderPortalGlobalStateModel) {
    return state.selectedUserPin;
  }

  @Selector()
  static SelectedOrderStatus(state: OrderPortalGlobalStateModel) {
    return state.selectedOrderStatus;
  }
}
